export default [{
  name: 'oauth/login',
  path: '/oauth/login',
  meta: {
    layout: 'OauthLayout'
  },
  component: require('@/pages/oauth/Login.vue').default
}]
